import React from 'react'

const SiteMain = ({ children }) => <main>{children}</main>

export default SiteMain
